// import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import 'material-design-icons-iconfont/dist/material-design-icons.css'; // Ensure you are using css-loader
import 'vuetify/dist/vuetify.min.css';
import Vue from 'vue';
import Vuetify from 'vuetify';
import zhHans from 'vuetify/src/locale/zh-Hans';
Vue.use(Vuetify);
const vuetifyOpts = {
    theme: {
        dark: false,
        themes: {
            light: {
                primary: '#44b2d2',
                secondary: '#424242',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
            },
        },
    },
    icons: {
        iconfont: 'md'
    },
    lang: {
        locales: { zhHans },
        current: 'zhHans',
    },
};
export default new Vuetify(vuetifyOpts);
